import * as React from "react"
import { Link } from "gatsby"
import { Container } from 'react-bootstrap'

import { Divider } from "@mui/material"

import Layout from "../components/layout"
import Seo from "../components/seo"
import 'bootstrap/dist/css/bootstrap.min.css';

const IndexPage = () => (
  <Layout>
    <Seo title="Introduction" />
    <Container>
    <h1>Introduction</h1>
		<article>
			<p>
				本网站提供关于新加坡华人会馆的消息，不仅包括<Link to="/clans/locality">地缘</Link>（乡亲）和<Link to="/clans/kinship">血缘</Link>（宗亲）会馆的基本消息，
				如中英文名称、成立年代、会所地址、联络信息、会员人数等，也利用地理信息系统 (Geographic Information Systems， 简称 GIS），提供会馆在新加坡地图中的确实位置，
				并且通过影像提供会馆位置及其周围环境的画面，让使用者能立体地了解会馆。
			</p>
			<section>
				<p>本网站对研究者还有几个有利的搜索功能：</p>
				<ol>
					<li>
						可搜索某个方言群会馆在新加坡的分布情况，也可以搜索所有方言群（福建、广东-广府、潮州、客家、海南、三江等）的分布情形，让研究者一目了然，了解方言群和地域分布的关系。
					</li>
					<li>
						可以新加坡某个地区（如芽笼区）为基准，搜索该地区有哪些方言群会馆；
					</li>
					<li>
						可以某个时段（如1965年至1985年）为基准，搜索那个时段有哪些会馆成立。
					</li>
				</ol>
			</section>

			<p>
        会馆信息中也包括了国大馆藏中所收的各会馆出版品。除此之外，本网站也有多个供研究者参考和使用的索引 (Index), 包括以<Link to="/clans/name">汉语拼音</Link>按所有会馆名称、
				按<Link to="/clans/locality">方言群和地缘</Link> (locality) 会馆名称、<Link to="/clans/kinship">姓氏和血缘</Link> (kinship) 会馆名称、
				会馆<Link to="/clans/all-year">成立年代</Link>而编制的索引，以期成为研究者便利的研究工具。
			</p>

			<p>本网站如有需要改进之处，希望使用者不吝指正。</p>

		</article>

    <Divider sx={{ mb: 2 }} />

    <article>
      <p>
        NUS Libraries provides comprehensive information about Chinese Clan Associations in Singapore, based on <Link>references</Link> collected in 2015. Using Pigeon Maps, these Associations have been mapped out on an interactive interface that allows you to:
      </p>

      <section>
        <ol>
          <li>
            Visualise the geographic patterns of <Link to="/clans/locality">dialect</Link> clan associations (by locality, i.e. Hokkien, Guangdong-Cantonese, Teochew, Hakka, Hainan, and Sanjiang) or <Link to="/clans/kinship">kinship</Link> clan associations (by surnames).
          </li>
          <li>
            Explore the distribution of the clan associations by zooming into or out of various geographic scales (e.g. Geylang and Chinatown). 
          </li>
          <li>
            Visualise the establishment of clan associations over time (e.g. from 1965 to 1985) using an interactive slider.
          </li>
          <li>
            Visualise the membership size of each clan association geographically.
          </li>
          <li>
            Browse relevant literature in NUS Libraries' collection.
          </li>
          <li>
            View indexes of clan associations sorted by <Link to="/clans/kinship">kinship</Link>, <Link to="/clans/locality">locality</Link>, <Link to="/clans/name">name</Link> (hanyu pinyin) or <Link to="/clans/all-year">year established</Link>.
          </li>
        </ol>
      </section>

      <p>
        Should you have feedback for improvement, please feel free to contact <a href="mailto:fengyikang@nus.edu.sg">Feng Yikang</a> or <a href="mailto:amylin@nus.edu.sg">Amy Lin</a>.
      </p>
    </article>
    </Container>

  </Layout>
)

export default IndexPage
